import {
  getFormInitialValues as rfGetFormInitialValues,
  getFormValues as rfGetFormValues,
  getFormSyncErrors,
  getFormMeta,
  getFormError,
} from 'redux-form';

export const getFormFieldInitialValue = (form, field) => state => (rfGetFormInitialValues(form)(state) || {})[field];

export const getFormValues = form => state => rfGetFormValues(form)(state) || {};
export const getFormFieldValue = (form, field, defaultValue) => state => {
  const value = getFormValues(form)(state)[field];
  return typeof value === 'undefined' ? defaultValue : value;
};

export const augmentSubmitActionWithAdditionalData = (action, extraData) => (data, dispatch) =>
  action(
    {
      ...data,
      ...extraData,
    },
    dispatch
  );

export const getFormErrors = formName => {
  const getMainError = getFormError(formName);
  const getErrors = getFormSyncErrors(formName);
  const getMeta = getFormMeta(formName);

  return state => {
    const formError = getMainError(state);
    const errors = getErrors(state);

    if (!errors && !formError) {
      return;
    }
    if (formError) {
      return formError;
    }

    const meta = getMeta(state) || {};
    const erroredFields = Object.keys(errors);
    const touchedErrors = erroredFields
      .filter(field => meta[field] && meta[field].touched && errors[field])
      .reduce((memo, field) => {
        memo[field] = errors[field];
        return memo;
      }, {});

    return touchedErrors;
  };
};

export const getFirstError = formName => {
  const getMainError = getFormError(formName);
  const getErrors = getFormSyncErrors(formName);
  const getMeta = getFormMeta(formName);

  return state => {
    const formError = getMainError(state);
    const errors = getErrors(state);

    if (!errors && !formError) {
      return;
    }
    if (formError) {
      return formError;
    }

    const meta = getMeta(state) || {};
    const erroredFields = Object.keys(errors);
    return errors[erroredFields.find(field => meta[field] && meta[field].touched)];
  };
};
